<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
    <form  #form="ngForm" style="display: flex; flex-direction: column; padding-bottom: 10px;">
        <tyl-form-field label='First Name'>
            <input #firstName matInput id='inpFrmaFirstName' name='FrmaFirstName' type='text' [(ngModel)]='person.FirstName' required/>
        </tyl-form-field>
        <tyl-form-field label='Middle Name'>
            <input matInput id='inpFrmaMiddleName' name='FrmaMiddleName' type='text' [(ngModel)]='person.MiddleName' />
        </tyl-form-field>
        <tyl-form-field label='Last Name'>
            <input #lastName matInput id='inpFrmaLastName' name='FrmaLastName' type='text' [(ngModel)]='person.LastName' required/>
        </tyl-form-field>
        <tyl-form-field label='Suffix'>
            <mat-select id='ddlFrmaSuffix' [(ngModel)]='selectedSuffix' name='FrmaSuffix' (selectionChange)="suffixChange()">
                <mat-option *ngFor='let suffix of suffixes' [value]='suffix'>{{suffix.CodeDescription}}</mat-option>
            </mat-select>
        </tyl-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-left'>
    </div>
    <div class='flex-footer-right'>
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="save.png" label="Save" (clickEvent)="saveClick()"></tyl-button>
        <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>